// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__v1PmO","logo":"header_logo__LaFpq","logo_mobile":"header_logo_mobile__9fNRJ","header_content":"header_header_content__fyzFs"};